import { Box, styled } from '@mui/material';

const ActionsRow = styled(Box)`
  display: flex;
  gap: 30px;
  width: max-content;
  margin-left: auto;
`;

export default ActionsRow;
